import {
    numberFormatUtils,
    baseNumberComparator,
} from '@instinet-analytics/core-lib';
import Column, { getBaseColumn } from './Column';
import ColumnType from './ColumnType';
import SortType from './SortType';

const { N2 } = numberFormatUtils;

const baseNumberColumn: Partial<Column<ColumnType.NUMBER>> = {
    ...getBaseColumn(ColumnType.NUMBER),
    sortCompareFunction: baseNumberComparator,
    textAlign: 'right',
};

export const advPct = {
    ...baseNumberColumn,
    name: 'ADV %',
    dataField: 'advPct',
    colFmt: N2,
    width: 75,
    tag: 'Market Data/ADV %',
    desc: 'Order Quantity percent of Average Daily Volume',
    defaultSortDesc: true,
    sortType: SortType.BLANK,
    isPercentage: true,
};

export const arrivalPSlip = {
    ...baseNumberColumn,
    name: 'Arrival Perf (bps)',
    dataField: 'arrivalPSlip',
    colFmt: N2,
    width: 75,
    tag: 'Order Data/Arrival Perf (bps)',
    desc: 'Performance versus Arrival price in basis points',
    defaultSortDesc: false,
    sortType: SortType.BLANK,
};

export const exCostTx = {
    ...baseNumberColumn,
    name: 'Est Cost bps (TradeSpex MIS)',
    dataField: 'exCostTx',
    colFmt: N2,
    width: 129,
    tag: 'Order Data/Est Cost bps (TradeSpex MIS)',
    desc: 'Estimated trade cost in bps (TradeSpex MIS model)',
    defaultSortDesc: true,
    sortType: SortType.BLANK,
};
